import React from "react";
import { Space, Row, Col } from "antd";
import EditableHoursTable from "../Tables/EditableHoursTable";
import useQueryGetHours from "../Api/useQueryGetHours";
import isLoading from "helperFunctions/_common/isLoading";
import { TablePaginationConfig } from "antd/lib/table";
import WROSearchbar from "../Searchbars/WROSearchbar";
import { WRO } from "services/BillingEngineService/interfaces/entities/WRO";

const PAGE_SIZE = 10;

function WROHoursPanel() {
  const [selectedWRO, setSelectedWRO] = React.useState<WRO | undefined>(undefined);

  const [page, setPage] = React.useState(1);

  const { resolvedData, status } = useQueryGetHours("wros", page, PAGE_SIZE, {
    wroIds: selectedWRO?.wroId,
  });

  const loading = isLoading([status]);

  function onSelect(wro?: WRO) {
    setSelectedWRO(wro);
  }

  const handleTableChange = (pagination: TablePaginationConfig) => {
    const nextPage = pagination.current || page;
    setPage(nextPage);
  };

  return (
    <Space style={{ width: "100%" }} size="large" direction="vertical">
      <WROSearchbar style={{ width: 400 }} dropdownMatchSelectWidth={400} onSelect={onSelect} />
      <Row>
        <Col span={24}>
          <EditableHoursTable
            type="wros"
            rows={resolvedData?.data || []}
            columns={[
              {
                title: "WRO",
                dataIndex: "wroId",
              },
            ]}
            onChange={handleTableChange}
            loading={loading}
            pagination={{
              current: page,
              pageSize: PAGE_SIZE,
              total: resolvedData?.meta?.data.total || 0,
            }}
          />
        </Col>
      </Row>
    </Space>
  );
}

export default WROHoursPanel;
